<template>
  <label class="c-switch" :class="[`c-switch--${props.size}`]">
    <input v-model="checked" type="checkbox" :value="props.value" :disabled="props.disabled" />
    <span v-if="$slots.default" class="flex flex-col">
      <slot />
    </span>
  </label>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { SwitchSize } from './types/SwitchSize';

const props = withDefaults(
  defineProps<{
    size?: SwitchSize;
    modelValue: string | boolean | number;
    value?: string | boolean | number;
    disabled?: boolean;
  }>(),
  {
    size: 'medium',
    value: true,
    disabled: false,
  }
);

const emit = defineEmits<{ (e: 'update:modelValue', value: string | boolean | number): any }>();

const checked = computed<string | boolean | number>({
  get() {
    // Return true unless the value is "0", 0, or "false"
    const valueStr = String(props.modelValue).toLowerCase();
    return !/^(0|false)$/.test(valueStr);
  },
  //preserve the original format of value (e.g "true"/"false", "1"/"0", 1/0 ...)
  set(val: string | boolean | number) {
    const original = props.modelValue;

    if (typeof original === 'boolean') {
      emit('update:modelValue', val);
    } else if (typeof original === 'string') {
      if (original.toLowerCase() === 'true' || original.toLowerCase() === 'false') {
        emit('update:modelValue', String(val));
      } else if (original === '1' || original === '0') {
        emit('update:modelValue', val ? '1' : '0');
      } else {
        emit('update:modelValue', val);
      }
    } else if (typeof original === 'number') {
      emit('update:modelValue', val ? 1 : 0);
    } else {
      emit('update:modelValue', val);
    }
  },
});
</script>

<script lang="ts">
export default {
  name: 'SeSwitch',
};
</script>
